// extracted by mini-css-extract-plugin
module.exports = {"container":"loading_container_container__3Bzdw","overlayText":"loading_container_overlayText__5HmGK"};